import {useSyncExternalStore} from 'react'
import {PROJECT_SELECTED_EVENT, readStoredProjectSelection} from '../constants'

const subscribe = (onChange: () => void) => {
  window.addEventListener(PROJECT_SELECTED_EVENT, onChange)
  window.addEventListener('storage', onChange)
  return () => {
    window.removeEventListener(PROJECT_SELECTED_EVENT, onChange)
    window.removeEventListener('storage', onChange)
  }
}

export const useProjectSelection = () => {
  const projects = useSyncExternalStore(subscribe, readStoredProjectSelection, readStoredProjectSelection)
  return {projects, projectIds: projects.map((project) => project.id), isPortfolio: projects.length > 1}
}
